import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import util from "@/libs/util";
import EnumApi from '@/api/enum';
export default {
  namespaced: true,
  state: {
    enumAll: {}
  },
  getters: {
    enumList: function enumList(state) {
      return function (code) {
        return state.enumAll[code] || [];
      };
    },
    enumLabel: function enumLabel(state) {
      return function (code, value) {
        var _ar = state.enumAll[code] || [];
        var _obj = _ar.find(function (item) {
          return item.value === value;
        });
        return _obj ? _obj.label : '';
      };
    }
  },
  actions: {
    asyncGetEnumAll: function asyncGetEnumAll(_ref) {
      var state = _ref.state,
        commit = _ref.commit;
      if (Object.keys(state.enumAll).length) {
        commit('setEnumAll', state.enumAll);
      } else {
        EnumApi.list().then(function (res) {
          var data = res.data || [];
          var obj = {
            trueORfalse: [{
              label: '是',
              value: 1
            }, {
              label: '否',
              value: 0
            }],
            useORclose: [{
              label: '启用',
              value: 1
            }, {
              label: '禁用',
              value: 0
            }],
            signUpStatus: [{
              label: '审核驳回',
              value: 0
            }, {
              label: '审核通过',
              value: 1
            }],
            orderStatus: [{
              label: '作废',
              value: 3
            }, {
              label: '有效',
              value: 2
            }]
          };
          data.forEach(function (item) {
            var dictDataList = item.value || [];
            var dicts = dictDataList.map(function (o) {
              return {
                value: o.code,
                label: o.desc
              };
            });
            obj[item.name] = dicts;
          });
          commit('setEnumAll', obj);
        });
      }
    }
  },
  mutations: {
    setEnumAll: function setEnumAll(state, value) {
      // console.log(value)
      state.enumAll = value;
    }
  }
};